import {combineValidators, required, maxLength, isPrice, isImage, isValidNumber, isValidString} from "../Validators";

export const AddMenuItemScheme = {
  name: combineValidators(required, isValidString),
  description: combineValidators(required, maxLength(500)),
  price: combineValidators(required, isPrice, isValidNumber),
  picturePath: combineValidators(required, isImage),
};